import * as React from 'react';
import GalleryCardLayout from '../GalleryCardLayout/GalleryCardLayout';
import { styled } from '@mui/system';

const WrapDiv = styled('div')(({ theme }) => ({
  width: '100%',
}));

const ActualDiv = styled('div')(({ theme }) => ({
  flex: '25%',
  padding: '4px',
  flexWrap: 'wrap',

  [theme.breakpoints.down('1000')]: {
    flex: '30%',
  },

  [theme.breakpoints.down('800')]: {
    flex: '50%',
    padding: '0px',
  },
}));

const ParentDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  padding: '1px',
  width: '100%',

  [theme.breakpoints.down('600')]: {
    display: 'flex',
    padding: '1px',
  },
}));

const GalleryCardGroup = (galleryCardData) => {
  const cardData = galleryCardData.galleryCardData;
  if (!galleryCardData) return '';
  let Column1 = [];
  let Column2 = [];
  let Column3 = [];
  let Column4 = [];
  let index = 0;
  cardData.map((data) => {
    if (index % 4 == 0) {
      Column1.push(<GalleryCardLayout key={data._id} props={data} />);
    } else if (index % 4 == 1) {
      Column2.push(<GalleryCardLayout key={data._id} props={data} />);
    } else if (index % 4 == 2) {
      Column3.push(<GalleryCardLayout key={data._id} props={data} />);
    } else {
      Column4.push(<GalleryCardLayout key={data._id} props={data} />);
    }
    index++;
  });

  return (
    <WrapDiv>
      <ParentDiv>
        <ActualDiv>{Column1}</ActualDiv>
        <ActualDiv>{Column2}</ActualDiv>
        <ActualDiv>{Column3}</ActualDiv>
        <ActualDiv>{Column4}</ActualDiv>
      </ParentDiv>
    </WrapDiv>
  );
};

export default GalleryCardGroup;
